export const throttleWithWaitLoading = (func: () => void, wait: number, isLoading: () => boolean): (() => void) & { cancel: () => void } => {
  let timeout: ReturnType<typeof setTimeout> | null = null

  const process = () => {
    func()
    timeout = null
  }

  const throttled = () => {
    if (!timeout) {
      timeout = setTimeout(() => {
        if (isLoading()) {
          // isLoadingがtrueならさらにwait後に再度チェック
          timeout = setTimeout(process, wait)
        }
        else {
          process()
        }
      }, wait)
    }
  }

  throttled.cancel = () => {
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
  }

  return throttled
}

export const throttle = <T extends (...args: any[]) => void>(
  func: T,
  wait: number,
): ((...args: Parameters<T>) => void) & { cancel: () => void } => {
  let timeout: ReturnType<typeof setTimeout> | null = null

  const throttled = (...args: Parameters<T>) => {
    if (!timeout) {
      timeout = setTimeout(() => {
        func(...args)
        timeout = null
      }, wait)
    }
  }

  throttled.cancel = () => {
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
  }

  return throttled
}

export const throttleWithCondition = (
  func: () => void,
  wait: number,
  condition: () => boolean,
): (() => void) & { cancel: () => void } => {
  const checkAndExecute = throttle(() => {
    if (condition()) {
      const delayedExecution = setTimeout(() => func(), wait)
      return () => clearTimeout(delayedExecution)
    }
    else {
      func()
    }
  }, wait)

  return checkAndExecute
}
